"use strict";

exports.__esModule = true;
exports.isNaN = isNaN;
exports.isNumber = isNumber;
exports.isNumeric = isNumeric;
require("core-js/modules/es.number.is-nan.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.regexp.exec.js");
function isNaN(value) {
  if (Number.isNaN) {
    return Number.isNaN(value);
  }

  // eslint-disable-next-line no-self-compare
  return value !== value;
}
function isNumber(value) {
  // @ts-ignore
  return !isNaN(+value) && isFinite(value);
}
function isNumeric(val) {
  return /^\d+(\.\d+)?$/.test(val);
}